var $94b60c866ca5dfe6$exports = {};
$94b60c866ca5dfe6$exports = {
    "Empty": `\u{7A7A}\u{767D}`
};


export {$94b60c866ca5dfe6$exports as default};
//# sourceMappingURL=zh-TW.module.js.map
